<div>
  <wu-header
    (menuClick)="mobileNavIsOpened.set(true)"
    (userIconClick)="profileTrayIsOpened.set(true)"
  />

  <div class="flex relative pt-12 lg:pt-16 w-full">
    <div
      class="hidden lg:block fixed w-60 overflow-hidden h-full text-walden-500 bg-white shadow-[0_8px_6px_0_rgba(0,0,0,0.25)]"
    >
      <wu-left-navigation />
    </div>
    <div class="w-full lg:pl-60 pb-2">
      <div class="overflow-x-hidden overflow-y-auto">
        <div class="relative">
          <wu-holds-notification />
          <div
            class="absolute top-full mt-3 inset-x-0 sm:inset-x-auto sm:right-[1%] z-[19] sm:w-96"
          >
            <wu-toaster-notification />
          </div>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <wu-bottom-sheet-layout
    [isOpened]="mobileNavIsOpened()"
    [showGlobalSearch]="true"
    (closed)="mobileNavIsOpened.set(false)"
  >
    <wu-left-navigation
      (click)="mobileNavIsOpened.set(false)"
    ></wu-left-navigation>
  </wu-bottom-sheet-layout>
  <wu-bottom-sheet-layout
    [isOpened]="profileTrayIsOpened()"
    [showGlobalSearch]="false"
    (closed)="profileTrayIsOpened.set(false)"
  >
    <wu-profile-tray />
  </wu-bottom-sheet-layout>
</div>
